
import { Table, TableBody, TableCell, TableHeader, TableHead, TableRow } from "@/components/ui/table";
import { PuttSituation } from "@/types/golf";

interface ScoreTableProps {
  situation: PuttSituation;
  scores: Record<string, number[]>;
  currentPoint: string;
  maxAttempts: number;
  totalPoints: number;
  currentIndex: number;
}

const ScoreTable = ({ 
  situation, 
  scores, 
  currentPoint, 
  maxAttempts, 
  totalPoints, 
  currentIndex 
}: ScoreTableProps) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden mt-6">
      <Table>
        <TableHeader>
          <TableRow className="bg-golf-50">
            <TableHead className="font-semibold text-golf-700">Point</TableHead>
            <TableHead className="font-semibold text-golf-700">Distance</TableHead>
            {Array.from({ length: maxAttempts }, (_, i) => (
              <TableHead key={i} className="font-semibold text-golf-700 text-center">
                Essai {i + 1}
              </TableHead>
            ))}
            <TableHead className="font-semibold text-golf-700 text-center">Total</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow>
            <TableCell className="font-medium">{currentPoint}</TableCell>
            <TableCell>{situation.distances[0].distance}m</TableCell>
            {Array.from({ length: maxAttempts }, (_, i) => (
              <TableCell key={i} className="text-center">
                <span className={`inline-block min-w-8 py-1 px-2 rounded ${
                  scores[currentPoint]?.[i] !== undefined
                    ? scores[currentPoint]?.[i] > 0
                      ? "bg-golf-100 text-golf-700"
                      : "bg-red-100 text-red-700"
                    : ""
                }`}>
                  {scores[currentPoint]?.[i] ?? "-"}
                </span>
              </TableCell>
            ))}
            <TableCell className="text-center font-semibold bg-golf-50">
              {totalPoints}
            </TableCell>
          </TableRow>
          <TableRow className="bg-gray-50">
            <TableCell colSpan={2 + maxAttempts} className="font-semibold text-right pr-4">
              Total Points
            </TableCell>
            <TableCell className="text-center font-bold text-golf-700">
              {totalPoints}
            </TableCell>
          </TableRow>
          <TableRow className="bg-gray-50">
            <TableCell colSpan={2 + maxAttempts} className="font-semibold text-right pr-4">
              Index
            </TableCell>
            <TableCell className="text-center font-bold text-golf-700">
              {currentIndex}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  );
};

export default ScoreTable;
